"use strict";
import React from "react";
import Store, { translateLogType, LogPagination } from "./IntegraitonplatformStore";
import { observer } from "mobx-react";
import Translate from "../../react-shared/Translations";
import { getEmptyTableContent } from "./integration-platform";
import { getEmptyTableFooter } from "./integration-platform";
import LoadingButton from "@mui/lab/LoadingButton";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PrintIcon from '@mui/icons-material/Print';
import ErrorIcon from "@mui/icons-material/Error";
import { AbnormalState } from "../../react-shared/EmptyState/AbnormalState";
import { Box, Typography, Pagination } from "@mui/material";

@observer
export class EventLogPage extends React.Component {
  constructor(props: any) {
    super(props);
  }

  getLogTableContent = (pagination: LogPagination) => {
    return (pagination.items ?? []).map((r, index) => {
      return (
        <tr key={index}>
          <td>{new Date(r.created).toLocaleString()}</td>
          <td>{translateLogType(r.type)}</td>
          <td>{r.logMessage}</td>
          <td>{r.extraData}</td>
        </tr>
      );
    });
  };

  getLogTableFooter = (pagination: LogPagination) => {
    return (
      <tr>
        <td colSpan={4}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Typography variant="h4">
            Showing {pagination.items.length} of {pagination.totalItemsCount} items
          </Typography>

          <Pagination
            count={pagination.totalPages}
            page={pagination.currentPage}
            onChange={(_, page) => Store.loadLogs((page - 1) * pagination.itemsPerPage + 1)}
            showFirstButton
            showLastButton
          />
        </Box>
        </td>
      </tr>
    );
  };

  render() {
    console.log(Store.EventLogTabState);
    return (
      <>
        <div style={{ padding: "10px" }}>
          <div style={{ paddingBottom: "10px" }}>
            <b>{Translate("IntegrationPlatform_From")}:</b>
            <input
              style={{ margin: "0 7px", padding: "2px 8px 2px 10px", border: "1px solid gray", borderRadius: "4px" }}
              type="date"
              value={Store.logsFromDate}
              onChange={(e) => Store.handleLogsFromDateValueChange(e.target.value)}
            />
            <b>{Translate("IntegrationPlatform_To")}:</b>
            <input
              style={{ margin: "0 7px", padding: "2px 8px 2px 10px", border: "1px solid gray", borderRadius: "4px" }}
              type="date"
              value={Store.logsToDate}
              onChange={(e) => Store.handleLogsToDateValueChange(e.target.value)}
            />
            <b>{Translate("IntegrationPlatform_CorrelationToken")}:</b>
            <input
              style={{ margin: "0 7px", padding: "2px 8px 2px 10px", border: "1px solid gray", borderRadius: "4px" }}
              type="text"
              value={Store.correlationToken}
              onChange={(e) => Store.handleCorrelationTokenValueChange(e.target.value)}
            />
            <b>{Translate("IntegrationPlatform_LogMessage")}:</b>
            <input
              style={{ margin: "0 7px", padding: "2px 8px 2px 10px", border: "1px solid gray", borderRadius: "4px", width: "300px" }}
              type="text"
              value={Store.logMessage}
              onChange={(e) => Store.handleLogMessageValueChange(e.target.value)}
            />
            <b>{Translate("IntegrationPlatform_LogLevel")}:</b>
            <select
              style={{ margin: "0 7px", padding: "2px 8px 2px 10px", border: "1px solid gray", borderRadius: "4px" }}
              value={Store.logLevel}
              onChange={(e) => Store.handleLogLevelValueChange(e.target.value)}
            >
              <option value="0">Trace</option>
              <option value="1">Debug</option>
              <option value="2" selected>Information</option>
              <option value="3">Warning</option>
              <option value="4">Error</option>
              <option value="5">Critical</option>
            </select>
            <LoadingButton
              style={{ margin: "0 10px", fontSize: "inherit", textTransform: "capitalize" }}
              disabled={Store.EventLogTabState == "LOADING"}
              loading={Store.EventLogTabState == "LOADING"}
              color="primary"
              variant="contained"
              loadingPosition="end"
              endIcon={
                Store.EventLogTabState == "ERROR" ? (
                  <>
                    <ErrorIcon />
                  </>
                ) : (
                  <>
                    <PlayArrowIcon sx={{ fontSize: "2.3rem" }} />
                  </>
                )
              }
              onClick={Store.search}
              title={Translate("IntegrationPlatform_SearchLogs")}
            >
              {Translate("IntegrationPlatform_SearchLogs")}
            </LoadingButton>
            <LoadingButton
              style={{ margin: "0 10px", fontSize: "inherit", textTransform: "capitalize" }}
              disabled={Store.ExportingButtonState == "LOADING"}
              loading={Store.ExportingButtonState == "LOADING"}
              color="primary"
              variant="contained"
              loadingPosition="end"
              endIcon={
                Store.ExportingButtonState == "ERROR" ? (
                  <>
                    <ErrorIcon />
                  </>
                ) : (
                  <>
                    <PrintIcon sx={{ fontSize: "2.3rem" }} />
                  </>
                )
              }
              onClick={Store.exportLogs}
              title={Translate("IntegrationPlatform_ExportLogs")}
            >
              {Translate("IntegrationPlatform_ExportLogs")}
            </LoadingButton>
          </div>
          {Store.EventLogTabState != "OK" ? (
            <AbnormalState
              stateOfPage={Store.EventLogTabState}
              headerText={Store.primaryStateText}
              message={Store.secondaryStateText}
            />
          ) : (
            <table className="table table-bordered table-striped separate">
              <thead>
                <tr>
                  <th style={{ width: "180px" }}>{Translate("IntegrationPlatform_Date")}</th>
                  <th>{Translate("IntegrationPlatform_Status")}</th>
                  <th>{Translate("IntegrationPlatform_Message")}</th>
                  <th>{Translate("IntegrationPlatform_ExtraInformation")}</th>
                </tr>
              </thead>
              <tbody>{Store.logTablePagination.totalItemsCount > 0 ? this.getLogTableContent(Store.logTablePagination) : getEmptyTableContent(4)}</tbody>
              <tfoot>{Store.logTablePagination.totalItemsCount > 0 ? this.getLogTableFooter(Store.logTablePagination) : getEmptyTableFooter(4)}</tfoot>
            </table>
          )}
        </div>
      </>
    );
  }
}
